import {AppConstants} from '@app/AppConstants';
import {ufn} from '@edifecs/fp-ui-lib';

/**
 * Utility to setup browser Ui items such as favicon and title.
 */
export class WindowUiSetup {

    /**
     * Setup app window ui
     */
    public static apply(): void {
        WindowUiSetup.setTitle();
        WindowUiSetup.setFavicon();
    }

    /**
     * Set app window title.
     */
    private static setTitle(): void {
        if (AppConstants.CMFA_MODE) {
            document.title = AppConstants.APP_TITLE_CMFA;
        } else {
            document.title = AppConstants.APP_TITLE_FPP;
        }
    }

    /**
     * Set app window favicon.
     */
    private static setFavicon(): void {
        let iconHref = '';
        if (AppConstants.CMFA_MODE) {
            const brandingLogo = null;
            if (ufn.isText(brandingLogo)) {
                iconHref = AppConstants.NAV_LOGO_CMFA === brandingLogo ? AppConstants.FAVICON_CMFA : brandingLogo;
            } else {
                iconHref = AppConstants.FAVICON_CMFA;
            }
        } else {
            iconHref = AppConstants.FAVICON_FPP;
        }

        let iconLink = document.head.querySelector('link[rel="icon"]');
        if (iconLink != null) {
            document.head.removeChild(iconLink);
        }
        iconLink = document.createElement('link');
        iconLink.setAttribute('rel', 'icon');
        iconLink.setAttribute('type', 'image/x-icon');
        iconLink.setAttribute('href', iconHref);
        document.head.appendChild(iconLink);
    }
}
